import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
// import classNames from "classnames";
// @material-ui/icons
import D1Icon from "@material-ui/icons/Palette";
import D2Icon from "@material-ui/icons/People";
import D3Icon from "@material-ui/icons/AssignmentTurnedIn";
import D4Icon from "@material-ui/icons/ImportantDevices";
import D5Icon from "@material-ui/icons/Favorite";
import D6Icon from "@material-ui/icons/Work";
import D7Icon from "@material-ui/icons/Games";
import withStyles from "@material-ui/core/styles/withStyles";
import domainTitleStyle from "assets/jss/material-kit-pro-react/components/domainTitleStyle.jsx";

function DomainTitle({ ...props }) {
  const { classes, domainId, domainName } = props;

  const renderDomainIcon = () => {
    switch (domainId) {
      case "D1":
        return <D1Icon />;
      case "D2":
        return <D2Icon />;
      case "D3":
        return <D3Icon />;
      case "D4":
        return <D4Icon />;
      case "D5":
        return <D5Icon />;
      case "D6":
        return <D6Icon />;
      case "D7":
        return <D7Icon />;
    }
  };
  return (
    <div className={classes.domainTitleStyle}>
      <h6 className={classes[domainId]}>
        {renderDomainIcon(domainId)}
        <span>{domainName}</span>
      </h6>
    </div>
  );
}

DomainTitle.defaultProps = {
  iconColor: "gray"
};

DomainTitle.propTypes = {
  classes: PropTypes.object.isRequired,
  domainId: PropTypes.string.isRequired,
  domainName: PropTypes.string.isRequired
};

export default withStyles(domainTitleStyle)(DomainTitle);
